import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

/**
 * Validator function to check if the password and confirm password fields match.
 * @param passwordControl The password control to compare against.
 * @returns A validator function that returns null if the passwords match, or an error object if they don't.
 */
export function passwordMatchValidator(
  passwordControl: AbstractControl,
): ValidatorFn {
  return (confirmPasswordControl: AbstractControl): ValidationErrors | null => {
    if (!confirmPasswordControl.value || !passwordControl.value) {
      return null;
    }

    return confirmPasswordControl.value === passwordControl.value
      ? null
      : { passwordMismatch: true };
  };
}
